import { compact } from 'es-toolkit/compat';

import { serviceMap, type UntranslatedServiceItem } from '../data/serviceData';

export type AppResponse = {
    items: AppInfo[];
};

export type AppInfo = {
    id: string;
};

export const mapToServiceList = (appsResponse: AppResponse): UntranslatedServiceItem[] =>
    compact(
        appsResponse.items.map((app: AppInfo): UntranslatedServiceItem | null => {
            const service = serviceMap[app.id];
            if (!service || service.hidden) {
                return null;
            }
            return service;
        })
    );
